var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C4.685 2 2 4.685 2 8C2 8.62 2.095 9.22 2.27 9.785C2.505 10.535 2.88 11.225 3.37 11.815C3.615 12.11 3.885 12.385 4.185 12.63C4.78 13.12 5.465 13.495 6.215 13.73C6.78 13.905 7.38 14 8 14C8.62 14 9.22 13.905 9.785 13.73C10.535 13.495 11.225 13.12 11.815 12.63C12.11 12.385 12.385 12.115 12.63 11.815C13.12 11.22 13.495 10.535 13.73 9.785C13.905 9.22 14 8.62 14 8C14 4.685 11.315 2 8 2ZM9.525 9.535C9.425 9.63 9.3 9.68 9.17 9.68C9.04 9.68 8.915 9.63 8.815 9.535L7.5 8.22V5.48C7.5 5.205 7.725 4.98 8 4.98C8.275 4.98 8.5 5.205 8.5 5.48V7.805L9.525 8.83C9.72 9.025 9.72 9.34 9.525 9.535Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlClock);
export default __webpack_public_path__ + "static/media/gl_clock.d69f37fab10cd9922810d10bc56d6ce2.svg";
export { ForwardRef as ReactComponent };